var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1723 44.0625V57.7174M58.8552 51.0417H43.3522M87.3471 45.4167V103C87.3471 104.105 86.4516 105 85.3471 105H17C15.8954 105 15 104.105 15 103V24.5C15 23.3954 15.8954 22.5 17 22.5H85.3471C86.4516 22.5 87.3471 23.3954 87.3471 24.5V45.4167Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4561 71.25H32.5",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4561 86.25H32.5",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.891 16.875H73.8763V30H27.5V16.875H40.4854C40.4854 10.6618 45.0533 5.625 50.6882 5.625C56.323 5.625 60.891 10.6618 60.891 16.875Z",
    fill: "#D1EAFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.891 16.875H58.891C58.891 17.9796 59.7864 18.875 60.891 18.875V16.875ZM73.8763 16.875H75.8763C75.8763 15.7704 74.9809 14.875 73.8763 14.875V16.875ZM73.8763 30V32C74.9809 32 75.8763 31.1046 75.8763 30H73.8763ZM27.5 30H25.5C25.5 31.1046 26.3954 32 27.5 32V30ZM27.5 16.875V14.875C26.3954 14.875 25.5 15.7704 25.5 16.875H27.5ZM40.4854 16.875V18.875C41.5899 18.875 42.4854 17.9796 42.4854 16.875H40.4854ZM60.891 18.875H73.8763V14.875H60.891V18.875ZM71.8763 16.875V30H75.8763V16.875H71.8763ZM73.8763 28H27.5V32H73.8763V28ZM29.5 30V16.875H25.5V30H29.5ZM27.5 18.875H40.4854V14.875H27.5V18.875ZM42.4854 16.875C42.4854 11.578 46.3373 7.625 50.6882 7.625V3.625C43.7694 3.625 38.4854 9.74558 38.4854 16.875H42.4854ZM50.6882 7.625C55.0391 7.625 58.891 11.578 58.891 16.875H62.891C62.891 9.74558 57.607 3.625 50.6882 3.625V7.625Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.167 72.9167L87.5003 61.25L110.834 72.9167C110.834 88.0636 102.713 109.404 87.5003 113.75C72.2878 109.404 64.167 88.0636 64.167 72.9167Z",
    fill: "#A3C5FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2507 81.6667L84.584 93.3334L78.7503 87.5M87.5003 61.25L64.167 72.9167C64.167 88.0636 72.2878 109.404 87.5003 113.75C102.713 109.404 110.834 88.0636 110.834 72.9167L87.5003 61.25Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.9c3a89d2.svg";
export { ForwardRef as ReactComponent };